import { getTvObject } from '@costar-ui/cosmos';

var surfaceOptions = getTvObject({
  color: {
    base: ['bg-base', 'text-on-base'],
    neutral: ['bg-neutral-subtler', 'text-on-neutral-subtler'],
    'primary-subtlest': ['bg-primary-subtlest', 'text-on-primary-subtlest'],
    'primary-contrast': ['bg-primary-contrast', 'text-on-primary-contrast']
  }
});
var surfaceOptions$1 = surfaceOptions;

export { surfaceOptions$1 as default };
//# sourceMappingURL=surface-options.esm.js.map
